import { TrackingEvent } from '@caresend/types';
import { formatTimeZoneDateSimple, formatTimeZoneDate, HOUR } from '@caresend/utils';
import { trackEvent } from '../../../../functions/tracking/tracking.js';
import { getStore } from '../../../../store/helpers/initStore.js';

/** Adds an hour to an existing TimeZoneDate */
const getTimeSlotEndDate = (date) => {
    if (!date.timestamp)
        return date;
    const endDate = { ...date, timestamp: date.timestamp + HOUR };
    return endDate;
};
const formatDateForRescheduling = (date) => {
    if (!date.timestamp)
        return 'Unknown date';
    const startTime = formatTimeZoneDateSimple(date, 'h');
    const endDate = getTimeSlotEndDate(date);
    const endTime = formatTimeZoneDate(endDate, 'h a');
    const displayDate = formatTimeZoneDateSimple(date, 'dddd, MMM. D');
    return `${displayDate} | ${startTime} - ${endTime}`;
};
const getBrickAndMortarVisitLabel = (date, isExamOneLab) => {
    const formattedDate = formatTimeZoneDateSimple(date, 'dddd, MMM. D, YYYY');
    const label = isExamOneLab ? 'Scheduled date' : 'Walk-in date';
    return `${label}: ${formattedDate}`;
};
const getMobileVisitLabel = (date) => {
    // Will only display the timezone if we are in a different timezone
    const startDate = formatTimeZoneDate(date, 'dddd, MMM. D');
    const endDate = getTimeSlotEndDate(date);
    const startTime = formatTimeZoneDateSimple(date, 'h');
    const endTime = formatTimeZoneDate(endDate, 'h a').toUpperCase();
    return `${startDate} | ${startTime} - ${endTime}`;
};
const trackSchedulingTimePicker = async () => {
    var _a, _b, _c;
    const store = getStore();
    const schedulingFlow = store.state.schedulingFlow;
    const { availableTimeSlots: timeSlotsByDate, isPaymentDisabled, } = schedulingFlow;
    const timeSlotResults = {
        earliest: { price: 0 },
        latest: { price: 0 },
        maxCost: { price: 0 },
        minCost: { price: 0 },
    };
    let numberTimeslot = 0;
    Object.values(timeSlotsByDate !== null && timeSlotsByDate !== void 0 ? timeSlotsByDate : {}).forEach((timeSlots, indexDate) => {
        Object.values(timeSlots).forEach((timeSlot, indexSlot) => {
            var _a, _b;
            numberTimeslot += 1;
            if (isPaymentDisabled)
                return;
            const price = (_b = (_a = timeSlot.priceInfo) === null || _a === void 0 ? void 0 : _a.visitPrice) !== null && _b !== void 0 ? _b : 0;
            if (indexDate === 0 && indexSlot === 0) {
                timeSlotResults.earliest = {
                    startTime: timeSlot.startTime,
                    price,
                };
            }
            if (indexDate === Object.values(timeSlotsByDate !== null && timeSlotsByDate !== void 0 ? timeSlotsByDate : {}).length - 1
                && indexSlot === Object.values(timeSlots !== null && timeSlots !== void 0 ? timeSlots : {}).length - 1) {
                timeSlotResults.latest = {
                    startTime: timeSlot.startTime,
                    price,
                };
            }
            if (price) {
                const currentMinCost = timeSlotResults.minCost.price;
                if (price < currentMinCost
                    || currentMinCost === 0) {
                    timeSlotResults.minCost = {
                        price,
                        startTime: timeSlot.startTime,
                    };
                }
                const currentMaxCost = timeSlotResults.maxCost.price;
                if (price > currentMaxCost
                    || currentMaxCost === 0) {
                    timeSlotResults.maxCost = {
                        price,
                        startTime: timeSlot.startTime,
                    };
                }
            }
        });
    });
    await trackEvent(store, TrackingEvent.SCHEDULING_TIME_PICKER, {
        address: (_a = schedulingFlow.draftWaypoint) === null || _a === void 0 ? void 0 : _a.location,
        draftWaypointID: (_b = schedulingFlow.draftWaypoint) === null || _b === void 0 ? void 0 : _b.id,
        numberOfTimeslots: numberTimeslot,
        officeID: (_c = schedulingFlow.draftWaypoint) === null || _c === void 0 ? void 0 : _c.officeID,
        patientPays: schedulingFlow.patientPays,
        timeSlotResults,
    });
};

export { formatDateForRescheduling, getBrickAndMortarVisitLabel, getMobileVisitLabel, trackSchedulingTimePicker };
